/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mock_Sermon_ThanksInputs */

const en_mock_sermon_thanks = /** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incredible. Accessing the notes now.`)
};

const es_mock_sermon_thanks = /** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increíble. Accediendo a las notas ahora.`)
};

const fr_mock_sermon_thanks = /** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incroyable. J'accède aux notes maintenant.`)
};

const de_mock_sermon_thanks = /** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unglaublich. Greife jetzt auf die Notizen zu.`)
};

const id_mock_sermon_thanks = /** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luar biasa. Mengakses catatannya sekarang.`)
};

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const ja_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const zh_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const ar_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const it_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const ru_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const pt_mock_sermon_thanks = en_mock_sermon_thanks;

/** @type {(inputs: Mock_Sermon_ThanksInputs) => LocalizedString} */
const ko_mock_sermon_thanks = en_mock_sermon_thanks;

/**
* | output |
* | --- |
* | "Incredible. Accessing the notes now." |
*
* @param {Mock_Sermon_ThanksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mock_sermon_thanks = /** @type {((inputs?: Mock_Sermon_ThanksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mock_Sermon_ThanksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mock_sermon_thanks(inputs)
	if (locale === "es") return es_mock_sermon_thanks(inputs)
	if (locale === "fr") return fr_mock_sermon_thanks(inputs)
	if (locale === "de") return de_mock_sermon_thanks(inputs)
	if (locale === "ja") return ja_mock_sermon_thanks(inputs)
	if (locale === "zh") return zh_mock_sermon_thanks(inputs)
	if (locale === "ar") return ar_mock_sermon_thanks(inputs)
	if (locale === "id") return id_mock_sermon_thanks(inputs)
	if (locale === "it") return it_mock_sermon_thanks(inputs)
	if (locale === "ru") return ru_mock_sermon_thanks(inputs)
	if (locale === "pt") return pt_mock_sermon_thanks(inputs)
	return ko_mock_sermon_thanks(inputs)
});